import { Suspense } from 'react';
import { Routes } from 'react-router-dom';

import AppLayout from 'layouts/app-layout';
import { PatientsProvider } from 'store/context/patient-context';
import { useReturnFallback } from 'utils/routes-fallback-utils';
import { ErrorBoundary } from 'views/error-boundry';
import { getRoutes } from 'utils/get-routes-utils';
import { appRoutes } from 'routes/app-routes';

function Main() {
  const fallback = useReturnFallback();

  return (
    <PatientsProvider>
      <ErrorBoundary>
        <AppLayout>
          <Suspense fallback={fallback}>
            <Routes>{getRoutes(appRoutes)}</Routes>
          </Suspense>
        </AppLayout>
      </ErrorBoundary>
    </PatientsProvider>
  );
}

export default Main;
